// extracted by mini-css-extract-plugin
module.exports = {"cookies":"CookiesModal_cookies__2Yd2u","text":"CookiesModal_text__O6umr","btn-close":"CookiesModal_btn-close__3BHnT"};